module.exports = __webpack_public_path__ + "static/media/image_289.3ea6251d.png";